import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import { WholesaleProvider } from './contexts/WholesaleContext';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ShopPage from './pages/ShopPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import OrderConfirmationPage from './pages/OrderConfirmationPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import AdminPhotoUpload from './pages/AdminPhotoUpload';
import AdminPage from './pages/AdminPage';
import WholesaleLoginPage from './pages/WholesaleLoginPage';
import WholesaleRegisterPage from './pages/WholesaleRegisterPage';
import WholesaleDashboardPage from './pages/WholesaleDashboardPage';
import './App.css';

function App() {
  return (
    <CartProvider>
      <WholesaleProvider>
        <BrowserRouter>
          <div className="App min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/shop" element={<ShopPage />} />
                <Route path="/product/:sku" element={<ProductDetailPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/order-confirmation/:orderId" element={<OrderConfirmationPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/admin/photos" element={<AdminPhotoUpload />} />
                <Route path="/admin" element={<AdminPage />} />
                {/* Wholesale Routes */}
                <Route path="/wholesale/login" element={<WholesaleLoginPage />} />
                <Route path="/wholesale/register" element={<WholesaleRegisterPage />} />
                <Route path="/wholesale/dashboard" element={<WholesaleDashboardPage />} />
              </Routes>
            </main>
            <Footer />
            <Toaster />
          </div>
        </BrowserRouter>
      </WholesaleProvider>
    </CartProvider>
  );
}

export default App;
